import React, { useEffect, useState } from "react";
import "./PlaylistPage.scss";
import { Link } from "react-router-dom";
import ControlPanel from "../../components/ControlPanel";
import { Button, Loader, ModalConfirm, Pagination, useNotification } from "../../components/UI";
import { usePlaylistStore } from "../../stores";
import { IFilters } from "../../types/default";
import PlaylistItem from "./PlaylistItem";
import { useTranslation } from "i18nano";
import PageContainer from "../../components/PageContainer";
import SortPanelContainer from "../../components/SortPanelContainer";
import SortPanelItem from "../../components/SortPanelContainer/SortPanelItem";

const PlaylistPage = () => {
    const { error, loading, fetchPlaylist, playlistList, selectPlaylist, deletePlaylist, clearStore } = usePlaylistStore(state => state);
    const { addNotific } = useNotification();
    const t = useTranslation();

    const [checkedAll, setCheckedAll] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const [filters, setFilters] = useState<IFilters>({
        page: 1,
        perPage: localStorage.getItem("perPage") ? Number(localStorage.getItem("perPage")) : 10,
        filters: { name: "" },
        orderBy: "name",
        orderDesk: false
    });

    useEffect(() => {
        return () => clearStore();
    }, []);

    useEffect(() => {
        if (error) {
            addNotific({
                title: t(error.title),
                body: t(error.body, { name: t("content.genitive") }),
                type: "danger"
            });
        }
    }, [error]);

    useEffect(() => {
        fetchPlaylist(filters);
        setCheckedAll(false);
    }, [filters]);

    const selectAll = (checkedState: boolean) => {
        selectPlaylist({ selectState: checkedState, selectedData: "all" });
        setCheckedAll(checkedState);
    };

    const filtersContent = (order_by: string) => {
        if (order_by === filters.orderBy) {
            setFilters(prev => ({ ...prev, orderDesk: !filters.orderDesk }));
        }
        setFilters(prev => ({ ...prev, orderBy: order_by }));
    };

    const onDelete = () => {
        const deleteList: Array<string> = [];
        for (const file of playlistList.data) {
            if (file.isChecked) {
                deleteList.push(file.id);
            }
        }
        deletePlaylist(deleteList);
        selectPlaylist({ selectState: false, selectedData: "all" });
        setCheckedAll(false);
    };

    return (
        <PageContainer>
            <ControlPanel
                onSelectAll={selectAll}
                onDelete={() => setShowConfirm(true)}
                onSearch={(val) => setFilters(prev => ({ ...prev, filters: { name: val } }))}
                righrPanel={
                    <Link to={"/playlists/create"}>
                        <Button variant={"primary"}>
                            {`${t("button.create")} ${t("playlist.one")}`}
                        </Button>
                    </Link>
                }
                selectedLenght={playlistList.data.filter(item => item.isChecked).length}
            />

            <SortPanelContainer>
                <SortPanelItem
                    type={"checkbox"}
                    onChange={(e) => selectAll(e.target.checked)}
                    checked={checkedAll}
                />
                <SortPanelItem
                    type={"text"}
                    text={t("table_head.name")}
                    onClick={() => filtersContent("name")}
                    filterable
                />
                <SortPanelItem
                    type={"text"}
                    text={t("table_head.description")}
                    onClick={() => filtersContent("description")}
                    filterable
                />
                <SortPanelItem
                    type={"text"}
                    text={t("table_head.actions")}
                />
            </SortPanelContainer>
            {loading
                ? <h1 style={{
                    "textAlign": "center",
                    "fontSize": "50px",
                    "marginTop": "100px"
                }}><Loader /></h1>
                : <>
                    {playlistList.data.length
                        ? <>
                            <div className={"content-table"}>
                                {playlistList.data.map((playlist) =>
                                    <PlaylistItem
                                        playlist={playlist}
                                        key={playlist.id}
                                    />
                                )}
                            </div>
                            <Pagination
                                perPage={filters.perPage}
                                setPerPage={(val) => setFilters(prev => ({ ...prev, perPage: val }))}
                                page={filters.page}
                                setPage={(val) => setFilters(prev => ({ ...prev, page: val }))}
                                count={playlistList.count}
                            />
                        </>
                        : <h1 style={{
                            "textAlign": "center",
                            "fontSize": "50px",
                            "marginTop": "100px"
                        }}>{t("missing.playlist")}</h1>
                    }
                </>
            }
            <ModalConfirm isShow={showConfirm} setIsShow={setShowConfirm} onConfirm={() => onDelete()} onCancel={() => { }}>
                <p>{t("confirm.delete", { name: `${t("elements")} (${playlistList.data.filter(item => item.isChecked).length})` })}</p>
            </ModalConfirm>
        </PageContainer>
    );
};

export default PlaylistPage;